import { useContext } from 'react';

import { HistoryContext } from '../contexts/HistoryContext';

export function useHistory() {
    const history = useContext(HistoryContext);

    if (!history) {
        throw new Error('HistoryContext is not initialized. Wrap your app in a "Router" component.');
    }

    return history;
}
